import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Section, SectionHeading, Eyebrow } from "@/public/ui";

export function FaqAccordion({ items, heading = "Questions, answered plainly" }) {
  const [open, setOpen] = useState(0);
  return (
    <Section className="py-16 sm:py-20">
      <Eyebrow>FAQ</Eyebrow>
      <SectionHeading className="mt-3 max-w-2xl">{heading}</SectionHeading>
      <div className="mt-10 divide-y divide-white/8 border-t border-white/8" data-testid="faq">
        {items.map(([q, a], i) => {
          const isOpen = open === i;
          return (
            <div key={q}>
              <button
                data-testid={`faq-q-${i}`}
                onClick={() => setOpen(isOpen ? -1 : i)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 py-5 text-left focus:outline-none focus:ring-2 focus:ring-tc-coach rounded"
              >
                <span className="text-base sm:text-lg font-medium text-tc-txt">{q}</span>
                <ChevronDown className={`w-5 h-5 shrink-0 text-tc-coach transition-transform ${isOpen ? "rotate-180" : ""}`} />
              </button>
              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }} className="overflow-hidden">
                    <p className="pb-6 pr-8 text-sm sm:text-base leading-relaxed text-tc-sub">{a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
